import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output } from "@angular/core";
import { CandidateMeetingModel, InterviewDashboardResult } from "../../interviews.models";
import { BookingType, InterviewStatus } from "../../interviews.enums";
import { GroupSlots } from "../../pages/interview-details/group-slots.interface";
import { Observable } from "rxjs";
import { HttpService } from "src/app/services/http.service";

@Component({
    selector: 'interview-dashboard',
    templateUrl: './interview-dashboard.component.html',
    standalone: false
})
export class InterviewDashboardComponent implements OnChanges {
  @Input() dashboardInfo: InterviewDashboardResult | null = null;
  @Input() upcomingMeetings: CandidateMeetingModel[] = [];
  @Input() pastMeetings: CandidateMeetingModel[] = [];

  @Output() onViewInterviewDetails: EventEmitter<CandidateMeetingModel> = new EventEmitter();

  public InterviewStatus = InterviewStatus;

  constructor(
    private httpService: HttpService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['upcomingMeetings']) {
      this.updateGroupMeetingSlots(this.upcomingMeetings);
    }
    if (changes['pastMeetings']) {
      this.updateGroupMeetingSlots(this.pastMeetings);
    }
  }

  private updateGroupMeetingSlots(meetings: CandidateMeetingModel[]) {
    for (let meeting of meetings) {
      if (meeting.bookingType === BookingType.GROUP) {
        this.getGroupMeetingSlots(meeting.id).subscribe(
          (groupSlots) => {
            meeting.groupMeetingSlots = groupSlots;
          }
        );
      }
    }
  }

  private getGroupMeetingSlots(meetingId: number): Observable<GroupSlots> {
    return this.httpService.getAllGroupMeetingsForCandidate(meetingId).pipe();
  }

  public getTimeOfDay():string{
    let hours = (new Date()).getHours();
    if (hours < 12){
      return 'Morning';
    } else if (hours < 18){
      return 'Afternoon';
    } else {
      return 'Evening';
    }
  }

  public viewInterviewDetails(model: CandidateMeetingModel) {
    this.onViewInterviewDetails.emit(model);
  }
}
